<template lang="pug">
  v-card
    v-card-title {{title}}
    v-card-text
      Charts(:data="chartData" :options="chartOptions").chart-container
</template>

<script>
import Charts from "@/components/Charts";
import Card from "@/components/Cards/Card.vue";

export default {
  components: { Charts, Card },
  props: {
    title: { type: String, default: "" },
    subTitle: { type: String, default: "" }
  },
  data: function() {
    return {
      plugins: {
        zoom: {
          // Container for pan options
          pan: {
            // Boolean to enable panning
            enabled: true,

            // Panning directions. Remove the appropriate direction to disable
            // Eg. 'y' would only allow panning in the y direction
            // A function that is called as the user is panning and returns the
            // available directions can also be used:
            //   mode: function({ chart }) {
            //     return 'xy';
            //   },
            mode: "xy",

            rangeMin: {
              // Format of min pan range depends on scale type
              x: null,
              y: null
            },
            rangeMax: {
              // Format of max pan range depends on scale type
              x: null,
              y: null
            }
          },

          // Container for zoom options
          zoom: {
            // Boolean to enable zooming
            enabled: true,

            // Enable drag-to-zoom behavior
            drag: true,

            // Drag-to-zoom effect can be customized
            // drag: {
            // 	 borderColor: 'rgba(225,225,225,0.3)'
            // 	 borderWidth: 5,
            // 	 backgroundColor: 'rgb(225,225,225)',
            // 	 animationDuration: 0
            // },

            // Zooming directions. Remove the appropriate direction to disable
            // Eg. 'y' would only allow zooming in the y direction
            // A function that is called as the user is zooming and returns the
            // available directions can also be used:
            //   mode: function({ chart }) {
            //     return 'xy';
            //   },
            mode: "xy",

            rangeMin: {
              // Format of min zoom range depends on scale type
              x: null,
              y: null
            },
            rangeMax: {
              // Format of max zoom range depends on scale type
              x: null,
              y: null
            },

            // Speed of zoom via mouse wheel
            // (percentage of zoom on a wheel event)
            speed: 0.1
          }
        }
      }
    };
  },
  computed: {
    simulationParams() {
      return this.$store.state.simulationParams;
    },
    simulation() {
      return this.$store.state.simulation.simulation;
    },
    signalsToPlot: {
      get: function() {
        return this.$store.state.chartData.signalsToPlot;
      },
      set: function(newValue) {
        this.$store.state.chartData.signalsToPlot = newValue;
      }
    },
    signalLabels() {
      return this.$store.state.chartData.signalLabels;
    },
    chartOptions() {
      return this.$store.state.chartData.options;
    },
    chartData() {
      return { ...this.$store.state.chartData.data };
    }
  },
  data: function() {
    return {
      signalAccel: true,
      switch1: true
    };
  },
  mounted: function() {
    this.updateChartData();
  },
  watch: {
    signalsToPlot: "updateChartData"
  },
  methods: {
    updateChartData: function() {
      this.$store.dispatch("chartData/updateData", this.simulation.signals);
    }
  }
};
</script>

<style scoped>
.chart-container {
  height: 500px;
}
</style>
